import { createFileRoute } from "@tanstack/react-router";
import { PreferencesPage } from "../features/account/preferences-page";

export const Route = createFileRoute("/_app/account/preferences")({ component: PreferencesPage });
